import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    showModal: false,
  },
  mutations: {
    SET_STATE_KEY_TRUE(state, key) {
      state[key] = true;
    },
    SET_STATE_KEY_FALSE(state, key) {
      state[key] = false;
    },
    SET_STATE_KEY_VALUE(state, object) {
      Vue.set(state, object.key, object.value);
    },
  },
  actions: {
    openModal({commit}) {
      commit('SET_STATE_KEY_TRUE', 'showModal');
    },
    closeModal({commit}) {
      commit('SET_STATE_KEY_FALSE', 'showModal');
    },
  },
})


import RdvEssai from "@/front/components/post-type/magasin/RdvEssai";
import RdvAtelier from "@/front/components/post-type/magasin/RdvAtelier";

if ([37557, 118575].includes(parseInt(g2rObj.postId))) {
  new Vue({
    store,
    el: '#rdv-essai',
    render: h => h(RdvAtelier)
  });
} else {
  new Vue({
    store,
    el: '#rdv-essai',
    render: h => h(RdvEssai)
  });
}
